import {h, Fragment} from "preact"
import { useAppState, useSelectedFiltersCount, useSort } from "@nosto/preact"
import { sortOptions, SIDEBAR_ID } from "../config"
import Icon from "./elements/Icon"
import Sidebar from "./Sidebar"
import { useEffect, useState, useRef } from 'preact/hooks'

function ToggleMobileSidebarButton({ lableFor, selectedFiltersCount, className }) {
    return (
        <label
            for={SIDEBAR_ID}
            className="ns-act-btn color-white w-50 nosto-sidebar-button"
        >
            <Icon name="filter" />
            <span>Show Filters</span>
            {/* {selectedFiltersCount > 0 && (
                <span className="ns-total-count ns-d-inline-block ns-text-align-center ns-font-3 ns-font-bold ns-color-white ns-background-primary ns-ml-1">
                    {selectedFiltersCount}
                </span>
            )} */}
        </label>
    )
}

export default function Toolbar({ lableFor, category }) {
    const { loading, query, response, pageType } = useAppState();
    const { activeSort, setSort } = useSort(sortOptions);
    const selectedFiltersCount = useSelectedFiltersCount();

    const [ sortIsActive, setSortIsActive ] = useState(false);
    const [ scrollYPosition, setScrollYPosition ] = useState(0);
    const toolbarRef = useRef(null);

    const handleSortChange = (event) => {
        setSort(event.target.value);
        setSortIsActive(false)
    }

    const docCount = response.products?.total ?? 0
    const totalSummary = pageType === "category" ? `${docCount} products` : `${docCount} results found for "${query.query}"`
    const options = sortOptions.map(o => ({ value: o.id, label: o.value.name }))
    const mobile = window.innerWidth <= 768;

    useEffect(() => {
        if (!mobile) return;
    
        const handleScroll = () => {
            setScrollYPosition(prevScrollYPosition => {
                const currentScrollYPosition = window.scrollY;
                if (currentScrollYPosition >= 200) {
                    if (currentScrollYPosition > prevScrollYPosition) {
                        toolbarRef.current?.classList.add("nav-hidden");
                    } else {
                        toolbarRef.current?.classList.remove("nav-hidden");
                    }
                } else {
                    if (toolbarRef.current) toolbarRef.current.style.transform = 'translateY(0)';
                }
                return currentScrollYPosition;
            });
        };
    
        window.addEventListener('scroll', handleScroll);
    
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []); 

    return (
        <>
            <div
                class={`searchbar-main-box container-xs debug-border-red ${category ? "hide" : ''}`}
                style={loading ? "opacity: 0.3; justify-content: end !important;" : ""}
            >
                {!loading && (
                    <div class="container-xs">
                        <div class="search-title text-center">
                            <h2>Search results</h2>
                        </div>
                        <div class="searchbar-bottom-text">
                            <p class="searchbar-result-heading">
                                <span data-nosto-element="totalResults">
                                    {totalSummary}
                                </span>
                            </p>
                        </div>
                    </div>
                )}
            </div>
            {mobile && <div
                class="mobile-filters"
                ref={toolbarRef}
            >
                <>
                    <ToggleMobileSidebarButton selectedFiltersCount={selectedFiltersCount} />
                    <Sidebar mobile />
                </>
                <div class="collection-list-topbar ns">
                    <div class="collection-list-filtersbar sorting-true">
                        <div class="filterby">
                            <div class="filterby-box">
                                <a href="#Collection-filter-sidebar" class="unstyled-link filter-item" data-side-drawer-open="">
                                <span class="filter-icon">
                                    <svg width="18" height="15" viewBox="0 0 18 15" fill="currentColor">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M18 3.00245C18 2.73723 17.8946 2.48288 17.7071 2.29534C17.5196 2.10781 17.2652 2.00245 17 2.00245L15.83 2.00245C15.6234 1.41692 15.2403 0.909884 14.7334 0.55124C14.2265 0.192596 13.6209 -1.91416e-07 13 -2.18557e-07C12.3791 -2.45698e-07 11.7735 0.192596 11.2666 0.55124C10.7597 0.909884 10.3766 1.41692 10.17 2.00245L1 2.00245C0.734783 2.00245 0.480429 2.10781 0.292892 2.29534C0.105356 2.48288 -1.19648e-07 2.73723 -1.31241e-07 3.00245C-1.42834e-07 3.26767 0.105356 3.52202 0.292892 3.70956C0.480429 3.89709 0.734783 4.00245 1 4.00245L10.17 4.00245C10.3766 4.58798 10.7597 5.09502 11.2666 5.45366C11.7735 5.8123 12.3791 6.0049 13 6.0049C13.6209 6.0049 14.2265 5.8123 14.7334 5.45366C15.2403 5.09502 15.6234 4.58798 15.83 4.00245L17 4.00245C17.2652 4.00245 17.5196 3.89709 17.7071 3.70956C17.8946 3.52202 18 3.26767 18 3.00245ZM13 4.00245C12.7348 4.00245 12.4804 3.89709 12.2929 3.70956C12.1054 3.52202 12 3.26767 12 3.00245C12 2.73723 12.1054 2.48288 12.2929 2.29534C12.4804 2.10781 12.7348 2.00245 13 2.00245C13.2652 2.00245 13.5196 2.10781 13.7071 2.29534C13.8946 2.48288 14 2.73723 14 3.00245C14 3.26767 13.8946 3.52202 13.7071 3.70956C13.5196 3.89709 13.2652 4.00245 13 4.00245ZM18 11.0025C18 10.7372 17.8946 10.4829 17.7071 10.2953C17.5196 10.1078 17.2652 10.0025 17 10.0025L8.83 10.0025C8.6234 9.41692 8.24026 8.90988 7.7334 8.55124C7.22654 8.19259 6.62091 8 6 8C5.37909 8 4.77346 8.19259 4.2666 8.55124C3.75974 8.90988 3.3766 9.41692 3.17 10.0025L1 10.0025C0.734783 10.0025 0.480428 10.1078 0.292892 10.2953C0.105356 10.4829 -4.69339e-07 10.7372 -4.80932e-07 11.0025C-4.92525e-07 11.2677 0.105356 11.522 0.292892 11.7096C0.480428 11.8971 0.734783 12.0025 0.999999 12.0025L3.17 12.0025C3.3766 12.588 3.75974 13.095 4.2666 13.4537C4.77346 13.8123 5.37909 14.0049 6 14.0049C6.62091 14.0049 7.22654 13.8123 7.7334 13.4537C8.24026 13.095 8.6234 12.588 8.83 12.0025L17 12.0025C17.2652 12.0025 17.5196 11.8971 17.7071 11.7096C17.8946 11.522 18 11.2677 18 11.0025ZM6 12.0025C5.73478 12.0025 5.48043 11.8971 5.29289 11.7096C5.10536 11.522 5 11.2677 5 11.0025C5 10.7372 5.10536 10.4829 5.29289 10.2953C5.48043 10.1078 5.73478 10.0025 6 10.0025C6.26522 10.0025 6.51957 10.1078 6.70711 10.2953C6.89464 10.4829 7 10.7372 7 11.0025C7 11.2677 6.89464 11.522 6.70711 11.7096C6.51957 11.8971 6.26522 12.0025 6 12.0025Z"></path>
                                    </svg>
                                </span>
                                Show Filter
                                </a>
                            </div>
                        </div>
                        <div class="sortby" data-mobile-sort="">
                            <div class="detail-box collection-sortby-inner">
                                <div 
                                    class="detail-summary collection-sortby-title"
                                    onClick={() => {
                                        setSortIsActive(prevSortIsActive => !prevSortIsActive)
                                    }}
                                >
                                        <span class="filter-icon">
                                            <svg width="16" height="10" viewBox="0 0 16 10" fill="none">
                                                <path d="M0 0H16V2H0V0Z" fill="currentColor"></path>
                                                <path d="M0 4H12V6H0V4Z" fill="currentColor"></path>
                                                <path d="M0 8H8V10H0V8Z" fill="currentColor"></path>
                                            </svg>
                                        </span>
                                    Sort by
                                </div>
                                {sortIsActive &&
                                <div class="sort-container">
                                    <div 
                                        class="active-value"
                                        onClick={() => {
                                            setSortIsActive(prevSortIsActive => !prevSortIsActive)
                                        }}
                                    >
                                        <div class="sortby-heading-box">
                                            <p class="sortby-heading-mobile">Sort By</p>
                                            <a class="filter-close-mobile" aria-label="Close" data-side-drawer-close="">
                                                <svg class="svg-filter-close-mobile" width="22" height="22" viewBox="0 0 22 22" fill="currentColor">
                                                    <path d="M21.7987 20.826L11.9721 10.9958L21.7987 1.16552C22.0561 0.899047 22.0561 0.476499 21.7987 0.20994C21.5349 -0.0632507 21.0997 -0.0708067 20.8266 0.193065L11 10.0233L1.17343 0.193149C0.907055 -0.0642582 0.484664 -0.0642582 0.218204 0.193149C-0.0548867 0.457021 -0.0624398 0.892415 0.201335 1.16561L10.0279 10.9958L0.201335 20.826C0.0724268 20.9549 1.71925e-08 21.1298 1.71925e-08 21.3122C-8.39964e-05 21.692 0.307751 21.9999 0.687425 22C0.869793 22.0002 1.04469 21.9276 1.17343 21.7984L11 11.9682L20.8266 21.7985C20.9553 21.9277 21.1303 22.0002 21.3127 22C21.4949 21.9999 21.6696 21.9275 21.7985 21.7987C22.0671 21.5301 22.0672 21.0946 21.7987 20.826Z"></path>
                                                </svg>
                                            </a>
                                        </div>
                                    </div>
                                    <ul class="unstylish-list collection-sortby-detail pos-absolute w-100 high-z" id="sort__list">
                                        {options.map(option => (
                                            <li 
                                                key={option.value}
                                                className="collection-sortby-item"
                                            >
                                                <div class="custom-checkbox radio-box">
                                                    <input 
                                                        class="checkmark-input" 
                                                        type="radio" 
                                                        name="sort_by" 
                                                        id={`sortByOption-toolbar-${option.value.toLowerCase().replaceAll(' ', '-')}`}
                                                        checked={activeSort === option.value}
                                                        value={option.value}
                                                        onChange={handleSortChange}
                                                    />
                                                    <label class={`${activeSort === option.value ? "active" : ""}`} for={`sortByOption-toolbar-${option.value.toLowerCase().replaceAll(' ', '-')}`}>
                                                        {option.label}
                                                    </label>
                                                </div>
                                            </li>
                                        ))
                                        }
                                    </ul>
                                </div>
                                }
                            </div>
                        </div>
                    </div>
                    </div>
            </div>}
        </>
    )
}